import { Container, Grid, Link } from "@mui/material";
import React from "react";

const Staking = () => {
    return(
        <div id="stake" className="OS---Staking py-5">
            <Container>
                <Grid
                    container
                    justifyConten="center"
                    alignContent="center"
                    className="py-md-5"
                >
                    <Grid
                        xs={12}
                    >
                        <h2 className="OS---sectionHeading text-dark">Sustainable Staking APY</h2>
                    </Grid>
                    <Grid
                        xs={12}
                        sm={9}
                        md={6}
                        className="text-center mx-auto"
                    >
                        <p className="text-dark">
                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
                        </p>
                        <h5 className="text-dark">8,514%</h5>
                        <p className="text-dark">OHMS Stacking APY</p>
                        <Link href="#" className="Global---menu-nav-btn bg-dark text-center px-5 mt-4">Stake Now</Link>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default Staking;